import React, { FC, useContext, useEffect, useState } from 'react';
import * as S from './VideoPlayer.styles';
import { Modal } from '../layout';
import ReactPlayer from 'react-player';
import { LayoutContext } from '../../../contexts/layoutContext';

interface IVideoPlayerProps {
  youtubeVideoID: string;
  authPage?: boolean;
  play?: boolean;
  setPlay?: React.Dispatch<React.SetStateAction<boolean>>;
  children: React.ReactElement;
}

export const VideoPlayer: FC<IVideoPlayerProps> = ({
  youtubeVideoID,
  authPage = true,
  play,
  children,
}) => {
  const { dispatch } = useContext(LayoutContext);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (play) openModal();
  }, [play]);

  const openModal = () => !showModal && setShowModal(true);

  const closeModal = () => {
    dispatch({
      type: 'SET_PLAY_VIDEO',
      payload: undefined,
    });
    setShowModal(false);
  };

  const content = (
    <div className="player-wrapper">
      {showModal && (
        <ReactPlayer
          width="100%"
          height="100%"
          url={`https://youtu.be/${youtubeVideoID}`}
          className="react-player"
          playing
          config={{
            youtube: {
              playerVars: { showinfo: 0 },
            },
          }}
        />
      )}
    </div>
  );

  return (
    <S.Container onClick={openModal}>
      {children}

      {showModal && (
        <Modal
          showModal={showModal}
          maxWidth={1000}
          handleClose={closeModal}
          component={content}
          authPage={authPage}
        />
      )}
    </S.Container>
  );
};
